
  <div class="container">
    <div class="row justify-content-center mt-5">
      <div class="col-xl-5 col-lg-6 col-md-8 col-sm-10">
        <div class="card shadow-sm border-0 rounded-4 ">
          <div class="card-body text-center">


            <div class="row justify-content-between">
              
            </div>

            <!-- Profile Image -->
            <div class="mb-3">
              <img
                class="rounded-circle border"
                src="assets/img/default-profile.png"
                alt="User profile"
                width="70"
                height="70"
              >
            </div>

            <!-- User Name -->
            <h5 class="fw-semibold mb-3">Hi, {{ user?.name || 'User' }}</h5>

            <!-- User Info -->
            <div class="text-start px-3">

              <div class="mb-3" *ngIf="user?.phoneNumber">
                <strong class="text-muted">Phone Number:</strong>
                <div class="text-dark">{{ user?.whatsappNumber || 'N/A' }}</div>
              </div>

              <div class="mb-3" *ngIf="user?.emailId">
                <strong class="text-muted">Email:</strong>
                <div class="text-dark">{{ user?.emailId || 'N/A' }}</div>
              </div>

              <div class="mb-3" *ngIf="user?.userAddress?.length">
                <strong class="text-muted">Address:</strong>
                <div class="text-dark">
                  {{ user?.userAddress[0]?.doorNo || '-' }},{{ user?.userAddress[0]?.landmark || '-' }}, {{ user?.userAddress[0]?.city || '-' }},
                  {{ user?.userAddress[0]?.state || '-' }} - {{ user?.userAddress[0]?.pinCode || '-' }}
                </div>
              </div>

            </div>

            <!-- Edit Profile Button -->
            <a (click)="openModel()" class="btn btn-outline-primary rounded-pill mt-3">
              <b>Edit Profile</b>
            </a>

          </div>
        </div>
      </div>
    </div>
  </div>



<div class="modal bg-custom" [style.display]="model ? 'block':'none'" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
    
      <!-- Header -->
      <div class="modal-header">
  <div>
    <h5 class="modal-title josefin-sans-bold mb-1">Update WhatsApp Contact Number</h5>
    <span class="text-danger" style="font-size: 12px;">
      * This phone number will be used to receive customer enquiries via WhatsApp. Please ensure it is active and correct.
    </span>
  </div>
  <button type="button" class="btn-close" (click)="openModel()" aria-label="Close"></button>
</div>

      <!-- Body -->
      <div class="modal-body">
        <form>
          <div class="row">
            <div class="form-floating mb-3 col-12">
            <input 
  type="text" 
  class="form-control" 
  [(ngModel)]="adminWhatsAppNumber"
  name="adminWhatsAppNumber"
  id="floatingInput" 
  placeholder="Enter Phone Number"
/>

              <label for="floatingInput" class="josefin-sans-regular">Name</label>
            </div>
          </div>
        </form>

      
        <span class="text-danger" *ngIf="updateError" style="font-size: 12px;">
  * Please enter a valid 10-digit phone number.
</span>


      </div>

      <!-- Footer -->
      <div class="modal-footer d-flex justify-content-center">
        <button 
          type="button" 
          class="btn btn-success josefin-sans-regular rounded-0"
          (click)="whatsAppNumber()" 
          data-bs-dismiss="modal"
        >
          Update
        </button>
      </div>

    </div>
  </div>
</div>
